import * as React from 'react';
import { memo } from 'react';
import styled from 'styled-components';
import { Box, Card } from '@mui/material';
import { Col, Flex, Tag } from 'antd';
import { MemberDataType, MemberTypeType } from '../../../../common/types';
import { colors, fonts } from '../../assets/constStyles';
import { ButtonMainRedLink } from '../button/ButtonMainRedLink';

const CardStyled = styled(Card)`
  width: 100%;
  box-shadow: rgba(145, 158, 171, 0.3) 0 0 2px 0, rgba(145, 158, 171, 0.12) 0 12px 24px -4px;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  position: relative;
  padding: 30px;
  height: 100%;

  && * {
    font-family: ${fonts.font2} !important;
  }
`;

const NameStyled = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
  font-weight: 400;
  min-height: 52px;
  text-transform: uppercase;
`;

const TagStyled = styled(Tag)`
  font-size: 16px;
  text-Transform: uppercase;
`;

interface IMemberCardItem {
  dataCard: MemberDataType,
}

const MemberCardItem: React.FC<IMemberCardItem> = ({ dataCard }) => {
  const getColorTag = (str: MemberTypeType) => {
    switch (str) {
      case 'Manufacturer':
        return <TagStyled color="geekblue">Manufacturer</TagStyled>;
      case 'Supplier':
        return <TagStyled color="green">Supplier</TagStyled>;
      case 'Allied':
        return <TagStyled color="purple">Allied</TagStyled>;
      case 'Life':
      default:
        return <TagStyled color="volcano">Life</TagStyled>;
    }
  };

  return (
        <Col xs={24} sm={8}>
            <CardStyled>
                <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      backgroundImage: 'url("../img/4935872.jpg")',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      opacity: 0.4,
                      zIndex: 0,
                    }}
                />
                <Flex flex={1} gap={10} vertical style={{ position: 'relative', zIndex: 1, height: '100%' }}>
                    <Flex justify={'flex-end'}>
                        {getColorTag(dataCard.type)}
                    </Flex>
                    <Flex vertical gap={10} wrap={'wrap'}>
                        <NameStyled style={{ fontSize: 20, fontWeight: 700 }}>{dataCard.name}</NameStyled>
                    </Flex>
                    {dataCard.contacts.main.phone && dataCard.contacts.main.email
                        && <Flex vertical>
                            <span style={{ fontSize: 18, fontWeight: 600 }}>Contact:</span>
                            <p style={{ fontSize: 20 }}>{dataCard.contacts.main.name}</p>
                            <a style={{ fontSize: 20, color: colors.colorRed }}
                               href={`tel: ${dataCard.contacts.main.phone}`}>{dataCard.contacts.main.phone}</a>
                            <a style={{ fontSize: 20, color: colors.colorRed }}
                               href={`mailto:${dataCard.contacts.main.email}`}>{dataCard.contacts.main.email}</a>
                        </Flex>
                    }
                    {
                        dataCard.contacts.main.address
                        && <Flex vertical style={{ margin: '20px 0' }}>
                            <span style={{ fontSize: 18, fontWeight: 600 }}>Location:</span>
                            <p style={{ fontSize: 20 }}>{dataCard.contacts.main.address}</p>
                        </Flex>
                    }
                    {
                        dataCard.contacts.main.website
                        && <Flex align={'center'} justify={'center'} style={{ marginTop: 'auto' }}>
                            <ButtonMainRedLink text={'Website'} route={dataCard.contacts.main.website}/>
                        </Flex>
                    }
                </Flex>
            </CardStyled>
        </Col>
  );
};

export default memo(MemberCardItem);
